import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  content
`

export const getOptionListsQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getOptionLists(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getOptionLists(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






